import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "message", "error", "additionalData", "dispatchSilentError", "dispatchError", "clearError"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import withStateHandlers from 'recompose/withStateHandlers';
import { ErrorMessage } from '@paysera/error-message-resolver';
import setHOCDisplayName from "../service/setHOCDisplayName";
import AdditionalErrorData from "../service/AdditionalErrorData";
var withErrorMessageState = compose(setHOCDisplayName('withErrorMessageState'), withStateHandlers({
  type: null,
  message: null,
  additionalData: null,
  error: null
}, {
  dispatchSilentError: function dispatchSilentError() {
    return function (message, error) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'danger';
      var additionalData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      return {
        message: message,
        type: type,
        additionalData: additionalData,
        error: error
      };
    };
  },
  dispatchError: function dispatchError() {
    return function (message, error) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'danger';
      var additionalData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      return {
        message: message,
        type: type,
        additionalData: additionalData,
        error: error
      };
    };
  },
  clearError: function clearError() {
    return function () {
      return {
        type: null,
        message: null,
        additionalData: null,
        error: null
      };
    };
  }
}), mapProps(function (_ref) {
  var type = _ref.type,
    message = _ref.message,
    error = _ref.error,
    additionalData = _ref.additionalData,
    dispatchSilentError = _ref.dispatchSilentError,
    dispatchError = _ref.dispatchError,
    clearError = _ref.clearError,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, restProps), {}, {
    errorMessageHandler: {
      type: type,
      message: message,
      error: error,
      additionalData: additionalData,
      dispatchSilentError: dispatchSilentError,
      dispatchError: dispatchError,
      clearError: clearError,
      hasError: error !== null
    }
  });
}));
export default withErrorMessageState;
export var withErrorMessageStatePropTypes = {
  errorMessageHandler: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(ErrorMessage)]),
    error: PropTypes.object,
    additionalData: PropTypes.instanceOf(AdditionalErrorData),
    dispatchSilentError: PropTypes.func.isRequired,
    dispatchError: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    hasError: PropTypes.bool.isRequired
  }).isRequired
};